import script from "./LoadTemplateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadTemplateModal.vue?vue&type=script&setup=true&lang=js"

import "./LoadTemplateModal.vue?vue&type=style&index=0&id=86931038&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86931038"]])

export default __exports__